import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route, Switch, Redirect } from 'react-router-dom'
import { AuthSelectors } from '../../modules/auth'

const { getSelectorAuth } = AuthSelectors

// const PrivateRoute = ({ component: Component, ...rest }) => (
//   <Route {...rest} render={props => (
//     rest.isAuthenticated ? (
//       <Component {...props}/>
//     ) : (
//       <Redirect to={{
//         pathname: '/login',
//         state: { from: props.location }
//       }}/>
//     )
//   )}/>
// )

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    <Component {...props}/>
  )}/>
)


const mapStateToProps = state => {
  return getSelectorAuth(state)
}

export default connect(mapStateToProps, {})(PrivateRoute)






// WEBPACK FOOTER //
// ./src/containers/PrivateRoute/index.js